import { useLang } from "../context/LanguageContext";
import { useAIAssistant } from "../context/AIAssistantContext";
import { serviceImages } from "../assets";

export const Services = () => {
  const { t } = useLang();
  const { openAssistant } = useAIAssistant();
  const items = t.services.items;

  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 sm:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-3xl">
          <div className="eyebrow">{t.services.eyebrow}</div>
          <h2
            data-testid="services-title"
            className="mt-5 font-[Outfit] text-4xl sm:text-5xl lg:text-6xl font-light text-white leading-[1.02] tracking-tight"
          >
            {t.services.title}
          </h2>
          <p className="mt-5 text-lg text-zinc-400 leading-relaxed">
            {t.services.subtitle}
          </p>
        </div>

        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-5">
          {items.map((item, idx) => {
            // Bento sizing
            const span = idx < 2 ? "lg:col-span-3" : "lg:col-span-2";
            const img = serviceImages[item.key];
            return (
              <div
                key={item.title}
                data-testid={`service-card-${idx}`}
                className={`fk-card-hover fk-glass rounded-2xl overflow-hidden ${span} group relative flex flex-col`}
              >
                {/* Image */}
                <div className="relative h-44 sm:h-52 overflow-hidden">
                  <img
                    src={img}
                    alt={item.title}
                    loading="lazy"
                    className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-[1.04] transition-all duration-700"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f12] via-[#0f0f12]/30 to-transparent" />
                  <div className="absolute top-4 left-4 w-11 h-11 rounded-xl bg-black/60 backdrop-blur-md border border-[#FF5A00]/30 inline-flex items-center justify-center text-[#FF5A00]">
                    <i className={`${item.icon} text-base`} />
                  </div>
                  <div className="absolute top-4 right-4 text-[10px] tracking-[0.28em] uppercase text-zinc-300/80 bg-black/50 backdrop-blur-md rounded-full px-3 py-1 border border-white/10">
                    0{idx + 1}
                  </div>
                </div>

                {/* Content */}
                <div className="p-7 pt-6 flex-1 flex flex-col">
                  <h3 className="font-[Outfit] text-2xl font-semibold text-white">
                    {item.title}
                  </h3>
                  <p className="mt-2 text-sm text-zinc-400 leading-relaxed">
                    {item.desc}
                  </p>
                  <ul className="mt-5 grid grid-cols-1 sm:grid-cols-2 gap-x-5 gap-y-2">
                    {item.points.map((p) => (
                      <li
                        key={p}
                        className="flex items-start gap-2 text-sm text-zinc-300"
                      >
                        <span className="mt-1.5 w-1 h-1 rounded-full bg-[#FF5A00] shrink-0" />
                        {p}
                      </li>
                    ))}
                  </ul>
                  <div className="mt-auto pt-6 border-t border-white/5 flex items-center justify-end">
                    <button
                      onClick={openAssistant}
                      data-testid={`service-link-${idx}`}
                      className="text-xs text-zinc-400 hover:text-[#FF5A00] inline-flex items-center gap-1.5 transition-colors"
                    >
                      {t.services.discover}{" "}
                      <i className="fa-solid fa-arrow-right text-[10px]" />
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
